/* eslint-disable array-callback-return */
/* eslint-disable @typescript-eslint/no-unused-expressions */
import M5APIs, { M5DocResponse } from "m5/M5APIs";
import moment from "moment";
import * as config from "../../../_config";

import {
  AggregationDone
} from "domains/models/AggregationModel";
import { AssessModel } from "domains/models/AssessModel";
import { TaskModel } from "domains/models/TaskModel";
import { UserModel } from "domains/models/UserModel";
import { action, computed, makeAutoObservable, observable } from "mobx";
import { EmployeeModel } from "../../../domains/models/EmployeeModel";

class EmployeeDetailPageStore {
  @observable private _employee?: EmployeeModel;
  @observable private _originTaskList: Array<TaskModel> = [];
  @observable private _taskList: Array<TaskModel> = [];
  @observable private _filterList: Array<TaskModel> = [];
  @observable _isLoading: boolean = false;

  @observable _selectedTask: TaskModel = {
    contents: "",
    created: 0,
    status: "TODO",
    subtype: "EMAIL",
    title: "",
    type: "TASK",
    children: [],
  };
  @observable _selectedAssess: AssessModel = {
    contents: "",
    subtype: "VISIBLE",
    title: "",
    type: "ASSESS",
    userId: "",

    userData: {},
  };

  @observable _isSkipOpenModal: boolean = false;
  @observable _isOpenModal: boolean = false;
  @observable _isCloseModal: boolean = false;
  @observable _isOpenEditModal: boolean = false;
  @observable _isCloseEditModal: boolean = false;
  @observable _tabsValue: string = "TODO";
  @observable _openPopper: boolean = false;
  @observable _emailCheck: boolean = true;
  @observable _groupwareCheck: boolean = true;
  @observable _chatCheck: boolean = true;
  @observable _attachCheck: boolean = true;
  @observable _chatAttachCheck: boolean = false;
  @observable _emailAttachCheck: boolean = false;
  @observable private _filterValue: string = "";
  @observable private _filterLikeUp: boolean = false;
  @observable private _filterLikeDown: boolean = false;
  @observable private _tempTaskList: Array<TaskModel> = [];
  @observable private _tempTaskEmailTotal: number = 0;
  @observable private _tempTaskChatTotal: number = 0;
  @observable private _emailPage: number = 0;
  @observable private _chatPage: number = 0;
  @observable private _todoPage: number = 0;
  @observable private _donePage: number = 0;
  @observable private _pageSize: number = 30;
  @observable private _isMoreBtn: boolean = false;
  @observable private _isHTMLOpen: boolean = false;
  @observable _teamIdList: string[] = [];
  @observable _channelIdList: string[] = [];
  @observable _total: number = 0;

  private _response: any = {
    docs: [],
    children: [],
  };

  private _userInfo: UserModel = {
    email: "",
    id: "",
    names: { fullname: "" },
    orgCode: "",
    paid: false,
    status: "",
    tier: "",
    username: "",
    userData: {
      aggregationId: "",
    },
  };

  constructor() {
    makeAutoObservable(this);
  }

  @action
  initStore() {
    this._filterLikeDown = false;
    this._filterLikeUp = false;
    this._filterValue = "";
    this._tempTaskList = [];
    this._tempTaskEmailTotal = 0;
    this._tempTaskChatTotal = 0;
    this._emailPage = 0;
    this._chatPage = 0;
    this._todoPage = 0;
    this._donePage = 0;
    this._isMoreBtn = false;
    this._response = {
      total: 0,
      docs: [],
      children: [],
    };
  }

  @action
  setTabsValue(tabsValue: string) {
    this._tabsValue = tabsValue;
  }

  @action
  setIsSkipOpenModal(isSkipOpenModal: boolean) {
    this._isSkipOpenModal = isSkipOpenModal;
  }

  @action
  setIsOpenModal(isOpenModal: boolean) {
    this._isOpenModal = isOpenModal;
  }

  @action
  setIsCloseModal(isCloseModal: boolean) {
    this._isCloseModal = isCloseModal;
  }
  @action
  setIsOpenEditModal(isOpenEditModal: boolean) {
    this._isOpenEditModal = isOpenEditModal;
  }

  @action
  setIsCloseEditModal(isCloseEditModal: boolean) {
    this._isCloseEditModal = isCloseEditModal;
  }

  @action
  setEmployee(employee: EmployeeModel) {
    this._employee = employee;
  }

  @action
  setOpenPopper(openPopper: boolean) {
    this._openPopper = openPopper;
  }

  @action
  setEmailCheck(emailCheck: boolean) {
    this._emailCheck = emailCheck;
    this.filterListWithChecked();
  }
  @action
  setGroupwareCheck(groupwareCheck: boolean) {
    this._groupwareCheck = groupwareCheck;
    this.filterListWithChecked();
  }
  @action
  setChatCheck(chatCheck: boolean) {
    this._chatCheck = chatCheck;
    this.filterListWithChecked();
  }

  @action
  setAttachCheck(attachCheck: boolean) {
    this._attachCheck = attachCheck;
    this.filterListWithChecked();
  }

  @action
  setChatAttachCheckWitoutFilter(attachCheck: boolean) {
    this._chatAttachCheck = attachCheck;
  }

  @action
  setChatAttachCheck(attachCheck: boolean) {
    this._chatAttachCheck = attachCheck;
    this.filterListWithChecked();
  }
  @action
  setEmailAttachCheck(attachCheck: boolean) {
    this._emailAttachCheck = attachCheck;
    this.filterListWithChecked();
  }

  @action
  async fetchMyTaskWithPeriod(userInfo: UserModel | undefined) {
    try {
      this._isLoading = true;
      // const res = await M5APIs.fetchDocs()
      console.log(this._filterValue);
      let period: any = {};
      // let like = {};
      const curYear = moment().year();
      const curMonth = moment().month() + 1;
      if (this._filterValue === "quarter") {
        let startMonth = 0;
        let endMonth = 2;
        // 1분기
        if (moment().format("Q") === "1") {
          startMonth = 0;
          endMonth = 2;
        }
        // 2분기
        else if (moment().format("Q") === "2") {
          startMonth = 3;
          endMonth = 5;
        }
        // 3분기
        else if (moment().format("Q") === "3") {
          startMonth = 6;
          endMonth = 8;
        }
        // 4분기
        else {
          startMonth = 9;
          endMonth = 11;
        }
        let newDate = new Date(curYear, startMonth, 1);
        let newDate2 = new Date(curYear, endMonth, 31);
        period = {
          condition: "AND",
          field: "created",
          compare: "BETWEEN",
          value: [moment(newDate).valueOf(), moment(newDate2).valueOf()],
        };
      } else if (this._filterValue === "half") {
        let startMonth = 0;
        let endMonth = 2;
        //전반기 일떄
        if (curMonth < 7) {
          startMonth = 0;
          endMonth = 5;
        }
        //후반기 일때
        else {
          startMonth = 6;
          endMonth = 11;
        }
        let newDate = new Date(curYear, startMonth, 1);
        let newDate2 = new Date(curYear, endMonth, 31);
        period = {
          condition: "AND",
          field: "created",
          compare: "BETWEEN",
          value: [moment(newDate).valueOf(), moment(newDate2).valueOf()],
        };
      } else if (this._filterValue === "year") {
        let newDate = new Date(curYear, 0, 1);
        let newDate2 = new Date(curYear, 11, 31);
        period = {
          condition: "AND",
          field: "created",
          compare: "BETWEEN",
          value: [moment(newDate).valueOf(), moment(newDate2).valueOf()],
        };
      } else if (this._filterValue === "last30day") {
        period = {
          condition: "AND",
          field: "created",
          compare: "BETWEEN",
          value: [moment().subtract(1, "month").valueOf(), moment().valueOf()],
        };
      } else {
        period = {
          condition: "AND",
          field: "created",
          compare: "BETWEEN",
          value: [moment().subtract(1, "month").valueOf(), moment().valueOf()],
        };
      }

      if (this._tabsValue === "DONE") {
        let tempUserList: any = [];
        const response1 = await M5APIs.fetchDocs<TaskModel>(
          config.BUCKET_TASK!,
          "TASK",
          {
            page: 0,
            pageSize: 30,
            orderBy: "userData.receivedDateTime",
            orderDirection: "DESC",
            fetchChildrenJson: [
              {
                types: "ASSESS",
                page: 0,
                pageSize: 300,
              },
            ],
            where: {
              filters: [
                period,
                {
                  condition: "AND",
                  field: "(",
                },
                {
                  field: "userData.`pubDoneIdList[]`",
                  compare: "IN",
                  value: [userInfo!.id],
                },
                {
                  condition: "OR",
                  field: "userData.`prvDoneIdList[]`",
                  compare: "IN",
                  value: [userInfo!.id],
                },
                {
                  field: ")",
                },

                //이메일 관련 조건
                {
                  condition: "AND",
                  field: "subtitle",
                  compare: "LIKE",
                  value: `Users/${this._userInfo?.userData.graphId}%`,
                },
                {
                  condition: "AND",
                  field: "userData.`sender`.`emailAddress`.`address`",
                  compare: "=",
                  value: this._employee?.email,
                },
                {
                  condition: "AND",
                  field: "subtype",
                  compare: "=",
                  value: "EMAIL",
                },
              ],
            },
          }
        ).then(async (res) => {
          let tempUserIdlist = new Set();
          for (let i = 0; i < res.children?.length; i++) {
            tempUserIdlist.add(res.children[i].userId);
          }
          let userRes = await M5APIs.fetchUsers({
            page: 0,
            pageSize: 200,
            where: JSON.stringify({
              filters: [
                {
                  condition: "AND",
                  field: "meta().id",
                  compare: "IN",
                  value: Array.from(tempUserIdlist),
                },
              ],
            }),
          });
          console.log(userRes);
          tempUserList = userRes.users;
          return res;
        });

        const targetChannels = this._employee?.userData.channels
          ? this._employee?.userData.channels
          : [];
        const myChannels = this._userInfo?.userData.channels
          ? this._userInfo?.userData.channels
          : [];
        const intersectionChannels = myChannels.filter((it) =>
          targetChannels.includes(it)
        );

        const response2 = await M5APIs.fetchDocs<TaskModel>(
          config.BUCKET_TASK!,
          "TASK",
          {
            // FIXME: of: me의 의미?
            // of: "me",
            page: 0,
            pageSize: 30,
            orderBy: "userData.createdDateTime",
            orderDirection: "DESC",
            fetchChildrenJson: [
              {
                types: "ASSESS",
                page: 0,
                pageSize: 300,
              },
            ],
            where: {
              filters: [
                period,
                {
                  condition: "AND",
                  field: "(",
                },
                {
                  field: "userData.`pubDoneIdList[]`",
                  compare: "IN",
                  value: [userInfo!.id],
                },
                {
                  condition: "OR",
                  field: "userData.`prvDoneIdList[]`",
                  compare: "IN",
                  value: [userInfo!.id],
                },
                {
                  field: ")",
                },

                // 채팅 관련 조건
                {
                  condition: "AND",
                  field: "userData.`from`.`user`.`id`",
                  compare: "=",
                  value: this._employee?.userData.graphId,
                },
                {
                  condition: "AND",
                  field: "userData.channelIdentity.channelId",
                  compare: "IN",
                  value: intersectionChannels,
                },
                {
                  condition: "AND",
                  field: "subtype",
                  compare: "=",
                  value: "CHAT",
                },
              ],
            },
          }
        ).then(async (res) => {
          let tempUserIdlist = new Set();
          for (let i = 0; i < res.children?.length; i++) {
            tempUserIdlist.add(res.children[i].userId);
          }
          let userRes = await M5APIs.fetchUsers({
            page: 0,
            pageSize: 200,
            where: JSON.stringify({
              filters: [
                {
                  condition: "AND",
                  field: "meta().id",
                  compare: "IN",
                  value: Array.from(tempUserIdlist),
                },
              ],
            }),
          });
          console.log(userRes);
          tempUserList = userRes.users;
          return res;
        });
        // console.log(response1);
        // console.log(response2);

        let response = {
          docs: [...(response1.docs ?? []), ...(response2.docs ?? [])],
          children: [
            ...(response1.children ?? []),
            ...(response2.children ?? []),
          ],
        };
        //console.log(response.docs);

        response.docs.sort((a: TaskModel, b: TaskModel) => {
          if (a.subtype === "EMAIL" && b.subtype === "EMAIL") {
            return (
              moment(b.userData?.receivedDateTime).valueOf() -
              moment(a.userData?.receivedDateTime).valueOf()
            );
          } else if (a.subtype === "EMAIL" && b.subtype === "CHAT") {
            return (
              moment(b.userData?.createdDateTime).valueOf() -
              moment(a.userData?.receivedDateTime).valueOf()
            );
          } else if (a.subtype === "CHAT" && b.subtype === "EMAIL") {
            return (
              moment(b.userData?.receivedDateTime).valueOf() -
              moment(a.userData?.createdDateTime).valueOf()
            );
          } else {
            return (
              moment(b.userData?.createdDateTime).valueOf() -
              moment(a.userData?.createdDateTime).valueOf()
            );
          }
        });

        for (let i = 0; i < response.children.length; i++) {
          const found = tempUserList?.find(
            (item: any) => item.id === response.children[i].userId
          );
          console.log(found);
          response.children[i].user = found;
        }

        response.docs.forEach((doc: TaskModel) => {
          let tempChildren: AssessModel[] = [];

          response.children?.forEach(async (child: any, index: number) => {
            if (doc.id === child.parentId) {
              tempChildren.push(child);
            }
          });
          doc.children = tempChildren;
        });

        console.log(this.filterLikeUp, this.filterLikeDown);
        if (this._filterLikeUp && this.filterLikeDown) {
          response.docs = response.docs.filter((doc: any) => {
            doc.children = doc.children.filter(
              (child: any) =>
                child.userData?.like === "true" ||
                child.userData?.like === "false"
            );
            if (doc.children.length === 0) {
              return false;
            } else {
              return true;
            }
          });
          console.log(response.docs);
        } else {
          if (this._filterLikeUp) {
            response.docs = response.docs.filter((doc: any) => {
              doc.children = doc.children.filter(
                (child: any) => child.userData?.like === "true"
              );
              if (doc.children.length === 0) {
                return false;
              } else {
                return true;
              }
            });
            console.log(response.docs);
          }
          if (this._filterLikeDown) {
            response.docs = response.docs.filter((doc: any) => {
              doc.children = doc.children.filter(
                (child: any) => child.userData?.like === "false"
              );
              if (doc.children.length === 0) {
                return false;
              } else {
                return true;
              }
            });
            console.log(response.docs);
          }
        }

        this._taskList = response.docs;
        this._originTaskList = response.docs;

        return response1;
      } else {
        let tempUserList: any = [];
        const response1 = await M5APIs.fetchDocs<TaskModel>(
          config.BUCKET_TASK!,
          "TASK",
          {
            page: this._emailPage,
            pageSize: 30,
            orderBy: "userData.receivedDateTime",
            orderDirection: "DESC",
            fetchChildrenJson: [
              {
                types: "ASSESS",
                page: 0,
                pageSize: 300,
              },
            ],
            where: {
              filters: [
                period,
                {
                  condition: "AND",
                  field: "(",
                },
                {
                  field: "userData.`pubDoneIdList`",
                  compare: "IS MISSING",
                },
                {
                  condition: "OR",
                  field:
                    "ARRAY_CONTAINS(userData.`pubDoneIdList`," +
                    `${userInfo!.id})`,
                  compare: "=",
                  value: false,
                },
                {
                  field: ")",
                },
                {
                  condition: "AND",
                  field: "(",
                },
                {
                  field: "userData.`prvDoneIdList`",
                  compare: "IS MISSING",
                },
                {
                  condition: "OR",
                  field:
                    "ARRAY_CONTAINS(userData.`prvDoneIdList`," +
                    `${userInfo!.id})`,
                  compare: "=",
                  value: false,
                },
                {
                  field: ")",
                },
                //이메일 관련 조건
                {
                  condition: "AND",
                  field: "subtitle",
                  compare: "LIKE",
                  value: `Users/${this._userInfo?.userData.graphId}%`,
                },
                {
                  condition: "AND",
                  field: "userData.`sender`.`emailAddress`.`address`",
                  compare: "=",
                  value: this._employee?.email,
                },
                {
                  condition: "AND",
                  field: "subtype",
                  compare: "=",
                  value: "EMAIL",
                },
              ],
            },
          }
        ).then(async (res) => {
          let tempUserIdlist = new Set();
          for (let i = 0; i < res.children?.length; i++) {
            tempUserIdlist.add(res.children[i].userId);
          }
          let userRes = await M5APIs.fetchUsers({
            page: 0,
            pageSize: 200,
            where: JSON.stringify({
              filters: [
                {
                  condition: "AND",
                  field: "meta().id",
                  compare: "IN",
                  value: Array.from(tempUserIdlist),
                },
              ],
            }),
          });
          console.log(userRes);
          tempUserList = userRes.users;
          return res;
        });

        const targetChannels = this._employee?.userData.channels
          ? this._employee?.userData.channels
          : [];
        const myChannels = this._userInfo?.userData.channels
          ? this._userInfo?.userData.channels
          : [];
        const intersectionChannels = myChannels.filter((it) =>
          targetChannels.includes(it)
        );

        const response2 = await M5APIs.fetchDocs<TaskModel>(
          config.BUCKET_TASK!,
          "TASK",
          {
            // FIXME: of: me의 의미?
            // of: "me",
            page: this._chatPage,
            pageSize: 30,
            orderBy: "userData.createdDateTime",
            orderDirection: "DESC",
            fetchChildrenJson: [
              {
                types: "ASSESS",
                page: 0,
                pageSize: 300,
              },
            ],
            where: {
              filters: [
                period,
                {
                  condition: "AND",
                  field: "(",
                },
                {
                  field: "userData.`pubDoneIdList`",
                  compare: "IS MISSING",
                },
                {
                  condition: "OR",
                  field: "userData.`pubDoneIdList[]`",
                  compare: "NOT IN",
                  value: userInfo!.id,
                },
                {
                  field: ")",
                },
                {
                  condition: "AND",
                  field: "(",
                },
                {
                  field: "userData.`prvDoneIdList`",
                  compare: "IS MISSING",
                },
                {
                  condition: "OR",
                  field: "userData.`prvDoneIdList[]`",
                  compare: "NOT IN",
                  value: userInfo!.id,
                },
                {
                  field: ")",
                },

                // 채팅 관련 조건
                {
                  condition: "AND",
                  field: "userData.`from`.`user`.`id`",
                  compare: "=",
                  value: this._employee?.userData.graphId,
                },
                {
                  condition: "AND",
                  field: "userData.channelIdentity.channelId",
                  compare: "IN",
                  value: intersectionChannels,
                },
                {
                  condition: "AND",
                  field: "subtype",
                  compare: "=",
                  value: "CHAT",
                },
              ],
            },
          }
        ).then(async (res) => {
          let tempUserIdlist = new Set();
          for (let i = 0; i < res.children?.length; i++) {
            tempUserIdlist.add(res.children[i].userId);
          }
          let userRes = await M5APIs.fetchUsers({
            page: 0,
            pageSize: 200,
            where: JSON.stringify({
              filters: [
                {
                  condition: "AND",
                  field: "meta().id",
                  compare: "IN",
                  value: Array.from(tempUserIdlist),
                },
              ],
            }),
          });
          //console.log(userRes);
          tempUserList = userRes.users;

          return res;
        });
        console.log(response1);
        console.log(response2);

        let response = {
          docs: [...(response1.docs ?? []), ...(response2.docs ?? [])],
          children: [
            ...(response1.children ?? []),
            ...(response2.children ?? []),
          ],
        };
        console.log(response.docs);

        response.docs.sort((a: TaskModel, b: TaskModel) => {
          if (a.subtype === "EMAIL" && b.subtype === "EMAIL") {
            return (
              moment(b.userData?.receivedDateTime).valueOf() -
              moment(a.userData?.receivedDateTime).valueOf()
            );
          } else if (a.subtype === "EMAIL" && b.subtype === "CHAT") {
            return (
              moment(b.userData?.createdDateTime).valueOf() -
              moment(a.userData?.receivedDateTime).valueOf()
            );
          } else if (a.subtype === "CHAT" && b.subtype === "EMAIL") {
            return (
              moment(b.userData?.receivedDateTime).valueOf() -
              moment(a.userData?.createdDateTime).valueOf()
            );
          } else {
            return (
              moment(b.userData?.createdDateTime).valueOf() -
              moment(a.userData?.createdDateTime).valueOf()
            );
          }
        });

        for (let i = 0; i < response.children.length; i++) {
          const found = tempUserList?.find(
            (item: any) => item.id === response.children[i].userId
          );
          console.log(found);
          response.children[i].user = found;
        }

        response.docs.forEach((doc: TaskModel) => {
          let tempChildren: AssessModel[] = [];

          response.children?.forEach(async (child: any, index: number) => {
            if (doc.id === child.parentId) {
              tempChildren.push(child);
            }
          });
          doc.children = tempChildren;
        });

        if (this._filterLikeUp) {
          response.docs = response.docs.filter((doc: any) => {
            doc.children = doc.children.filter(
              (child: any) => child.userData.like === "true"
            );
            if (doc.children.length === 0) {
              return false;
            } else {
              return true;
            }
          });
          console.log(response.docs);
        }

        this._taskList = response.docs;
        this._originTaskList = response.docs;

        return response1;
      }
    } catch (err: any) {
      throw err;
    } finally {
      this._isLoading = false;
    }
  }

  @action
  filterListWithChecked() {
    if (this._emailCheck && this._chatCheck) {
      if (this._chatAttachCheck) {
        this._filterList = this._originTaskList.filter((task: TaskModel) => {
          if (task.subtype === "CHAT") {
            return task.userData?.hasAttachments;
          } else {
            return true;
          }
        });
      } else {
        this._filterList = this._originTaskList;
      }
    } else if (this._emailCheck && !this._chatCheck) {
      this._filterList = this._originTaskList.filter(
        (task: TaskModel) => task.subtype === "EMAIL"
      );
    } else if (!this._emailCheck && this._chatCheck) {
      if (this._chatAttachCheck) {
        this._filterList = this._originTaskList.filter((task: TaskModel) => {
          if (task.subtype === "CHAT") {
            return task.userData?.hasAttachments;
          } else {
            return false;
          }
        });
      } else {
        this._filterList = this._originTaskList.filter(
          (task: TaskModel) => task.subtype === "CHAT"
        );
      }
    } else {
      this._filterList = [];
    }

    const tabPage =
      this._tabsValue === "DONE" ? this._donePage : this._todoPage;

    this._taskList = this._filterList.slice(
      this._pageSize * (tabPage - 1),
      this._pageSize * tabPage
    );

    this.decideIfhavingMoreData();
  }

  @action
  async fetchEmailData() {
    return await M5APIs.fetchDocs<TaskModel>(config.BUCKET_TASK!, "TASK", {
      page: this._emailPage,
      pageSize: this._pageSize,
      orderBy: "userData.receivedDateTime",
      orderDirection: "DESC",
      fetchChildrenJson: [
        {
          types: "ASSESS",
          page: 0,
          pageSize: 300,
        },
      ],
      where: {
        filters: [
          {
            condition: "AND",
            field: "(",
          },
          {
            field: "userData.`pubDoneIdList`",
            compare: "IS MISSING",
          },
          {
            condition: "OR",
            field:
              "ARRAY_CONTAINS(userData.`pubDoneIdList`," +
              `${this._userInfo!.id})`,
            compare: "=",
            value: false,
          },
          {
            field: ")",
          },
          {
            condition: "AND",
            field: "(",
          },
          {
            field: "userData.`prvDoneIdList`",
            compare: "IS MISSING",
          },
          {
            condition: "OR",
            field:
              "ARRAY_CONTAINS(userData.`prvDoneIdList`," +
              `${this._userInfo!.id})`,
            compare: "=",
            value: false,
          },
          {
            field: ")",
          },
          //이메일 관련 조건
          {
            condition: "AND",
            field: "subtitle",
            compare: "LIKE",
            value: `Users/${this._userInfo?.userData.graphId}%`,
          },
          {
            condition: "AND",
            field: "userData.`sender`.`emailAddress`.`address`",
            compare: "=",
            value: this._employee?.email,
          },
          {
            condition: "AND",
            field: "subtype",
            compare: "=",
            value: "EMAIL",
          },
        ],
      },
    });
  }
  @action
  async fetchDoneEmailData() {
    return await M5APIs.fetchDocs<TaskModel>(config.BUCKET_TASK!, "TASK", {
      page: this._emailPage,
      pageSize: this._pageSize,
      orderBy: "userData.receivedDateTime",
      orderDirection: "DESC",
      fetchChildrenJson: [
        {
          types: "ASSESS",
          page: 0,
          pageSize: 300,
        },
      ],
      where: {
        filters: [
          {
            condition: "AND",
            field: "(",
          },
          {
            field: "userData.`pubDoneIdList[]`",
            compare: "IN",
            value: [this._userInfo!.id],
          },
          {
            condition: "OR",
            field: "userData.`prvDoneIdList[]`",
            compare: "IN",
            value: [this._userInfo!.id],
          },
          {
            field: ")",
          },

          //이메일 관련 조건
          {
            condition: "AND",
            field: "subtitle",
            compare: "LIKE",
            value: `Users/${this._userInfo?.userData.graphId}%`,
          },
          {
            condition: "AND",
            field: "userData.`sender`.`emailAddress`.`address`",
            compare: "=",
            value: this._employee?.email,
          },
          {
            condition: "AND",
            field: "subtype",
            compare: "=",
            value: "EMAIL",
          },
        ],
      },
    });
  }

  @action
  async fetchDoneChatData() {
    const targetChannels = this._employee?.userData.channels
      ? this._employee?.userData.channels
      : [];
    const myChannels = this._userInfo?.userData.channels
      ? this._userInfo?.userData.channels
      : [];

    if (targetChannels.length == 0 || myChannels.length == 0) {
      return { total: 0, docs: [], children: [] };
    }

    const intersectionChannels = myChannels.filter((it) =>
      targetChannels.includes(it)
    );

    return await M5APIs.fetchDocs<TaskModel>(config.BUCKET_TASK!, "TASK", {
      page: this._chatPage,
      pageSize: this._pageSize,
      orderBy: "userData.createdDateTime",
      orderDirection: "DESC",
      fetchChildrenJson: [
        {
          types: "ASSESS",
          page: 0,
          pageSize: 300,
        },
      ],
      where: {
        filters: [
          {
            condition: "AND",
            field: "(",
          },
          {
            field: "userData.`pubDoneIdList[]`",
            compare: "IN",
            value: [this._userInfo!.id],
          },
          {
            condition: "OR",
            field: "userData.`prvDoneIdList[]`",
            compare: "IN",
            value: [this._userInfo!.id],
          },
          {
            field: ")",
          },

          // 채팅 관련 조건
          {
            condition: "AND",
            field: "userData.`from`.`user`.`id`",
            compare: "=",
            value: this._employee?.userData.graphId,
          },
          {
            condition: "AND",
            field: "userData.channelIdentity.channelId",
            compare: "IN",
            value: intersectionChannels,
          },
          {
            condition: "AND",
            field: "subtype",
            compare: "=",
            value: "CHAT",
          },
        ],
      },
    });
  }

  @action
  async fetchChatData() {
    const targetChannels = this._employee?.userData.channels
      ? this._employee?.userData.channels
      : [];
    const myChannels = this._userInfo?.userData.channels
      ? this._userInfo?.userData.channels
      : [];

    if (targetChannels.length == 0 || myChannels.length == 0) {
      return { total: 0, docs: [], children: [] };
    }

    const intersectionChannels = myChannels.filter((it) =>
      targetChannels.includes(it)
    );

    return await M5APIs.fetchDocs<TaskModel>(config.BUCKET_TASK!, "TASK", {
      page: this._chatPage,
      pageSize: this._pageSize,
      orderBy: "userData.createdDateTime",
      orderDirection: "DESC",
      fetchChildrenJson: [
        {
          types: "ASSESS",
          page: 0,
          pageSize: 300,
        },
      ],
      where: {
        filters: [
          {
            condition: "AND",
            field: "(",
          },
          {
            field: "userData.`pubDoneIdList`",
            compare: "IS MISSING",
          },
          {
            condition: "OR",
            field: "userData.`pubDoneIdList[]`",
            compare: "NOT IN",
            value: this._userInfo!.id,
          },
          {
            field: ")",
          },
          {
            condition: "AND",
            field: "(",
          },
          {
            field: "userData.`prvDoneIdList`",
            compare: "IS MISSING",
          },
          {
            condition: "OR",
            field: "userData.`prvDoneIdList[]`",
            compare: "NOT IN",
            value: this._userInfo!.id,
          },
          {
            field: ")",
          },
          // 채팅 관련 조건
          {
            condition: "AND",
            field: "userData.`from`.`user`.`id`",
            compare: "=",
            value: this._employee?.userData.graphId,
          },
          {
            condition: "AND",
            field: "userData.channelIdentity.channelId",
            compare: "IN",
            value: intersectionChannels,
          },
          {
            condition: "AND",
            field: "subtype",
            compare: "=",
            value: "CHAT",
          },
        ],
      },
    });
  }

  async fetchUsers(tempUserIdlist: Set<String>) {
    let userList = [];
    if (tempUserIdlist.size > 0) {
      let userRes = await M5APIs.fetchUsers({
        page: 0,
        pageSize: tempUserIdlist.size,
        where: JSON.stringify({
          filters: [
            {
              condition: "AND",
              field: "meta().id",
              compare: "IN",
              value: Array.from(tempUserIdlist),
            },
          ],
        }),
      });
      userList = userRes.users ?? [];
    }

    return userList;
  }

  buildEmail(
    isDoneTask: boolean,
    tempUserList: any,
    responseEmail: M5DocResponse<TaskModel>
  ) {
    /**
     * 1. 병합
     */
    this._response = {
      docs: [...this._response.docs, ...(responseEmail.docs ?? [])],
      children: [...this._response.children, ...(responseEmail.children ?? [])],
    };

    /**
     * 3. user 정보 연동
     */
    for (let i = 0; i < this._response.children.length; i++) {
      const found = tempUserList?.find(
        (item: any) => item.id === this._response.children[i].userId
      );
      this._response.children[i].user = found;
    }

    /**
     * 4. 평가정보(AssessModel) 연동
     */
    if (isDoneTask) {
      this._response.docs.forEach((doc: TaskModel) => {
        let tempChildren: AssessModel[] = [];

        this._response.children?.forEach(async (child: any, index: number) => {
          if (doc.id === child.parentId) {
            tempChildren.push(child);
          }
        });
        doc.children = tempChildren;
      });
    }

    this._originTaskList = this._response.docs;

    return responseEmail;
  }

  buildChatAndSort(
    isDoneTask: boolean,
    tempUserList: any,
    responseChat: M5DocResponse<TaskModel>
  ) {
    /**
     * 1. 병합
     */

    this._response = {
      docs: [...this._response.docs, ...(responseChat.docs ?? [])],
      children: [...this._response.children, ...(responseChat.children ?? [])],
    };

    /**
     * 2. 정렬
     */
    this._response.docs.sort((a: TaskModel, b: TaskModel) => {
      if (a.subtype === "EMAIL" && b.subtype === "EMAIL") {
        return (
          moment(b.userData?.receivedDateTime).valueOf() -
          moment(a.userData?.receivedDateTime).valueOf()
        );
      } else if (a.subtype === "EMAIL" && b.subtype === "CHAT") {
        return (
          moment(b.userData?.createdDateTime).valueOf() -
          moment(a.userData?.receivedDateTime).valueOf()
        );
      } else if (a.subtype === "CHAT" && b.subtype === "EMAIL") {
        return (
          moment(b.userData?.receivedDateTime).valueOf() -
          moment(a.userData?.createdDateTime).valueOf()
        );
      } else {
        return (
          moment(b.userData?.createdDateTime).valueOf() -
          moment(a.userData?.createdDateTime).valueOf()
        );
      }
    });

    /**
     * 3. user 정보 연동
     */
    for (let i = 0; i < this._response.children.length; i++) {
      const found = tempUserList?.find(
        (item: any) => item.id === this._response.children[i].userId
      );
      //console.log(found);
      this._response.children[i].user = found;
    }

    /**
     * 4. 평가정보(AssessModel) 연동
     */
    if (isDoneTask) {
      this._response.docs.forEach((doc: TaskModel) => {
        let tempChildren: AssessModel[] = [];

        this._response.children?.forEach(async (child: any, index: number) => {
          if (doc.id === child.parentId) {
            tempChildren.push(child);
          }
        });
        doc.children = tempChildren;
      });
    }

    this._originTaskList = this._response.docs;

    return responseChat;
  }

  @action
  decideIfhavingMoreData() {
    const _tempEmailPageSize = this._emailPage * this._pageSize;
    const _tempChatPageSize = this._chatPage * this._pageSize;

    let showMoreBtn = false;
    if (this._tempTaskEmailTotal > _tempEmailPageSize) {
      showMoreBtn = true;
    }
    if (this._tempTaskChatTotal > _tempChatPageSize) {
      showMoreBtn = true;
    }
    if (this._filterList.length > this._taskList.length) {
      showMoreBtn = true;
    }

    this._isMoreBtn = showMoreBtn;
  }

  async fetchDoneTaskList() {
    let tempUserList: any = [];
    let tempUserIdlist = new Set<String>();
    this._donePage++;
    const responseEmail = await this.fetchDoneEmailData().then(async (res) => {
      for (let i = 0; i < res.children?.length; i++) {
        tempUserIdlist.add(res.children[i].userId);
      }
      // const userList = await this.fetchUsers(res);
      // tempUserList = [...userList];
      return res;
    });
    this._emailPage++;

    this.buildEmail(true, tempUserList, responseEmail);
    this.filterListWithChecked();

    const responseChat = await this.fetchDoneChatData().then(async (res) => {
      for (let i = 0; i < res.children?.length; i++) {
        tempUserIdlist.add(res.children[i].userId);
      }

      const userList = await this.fetchUsers(tempUserIdlist);
      tempUserList = [...userList];
      return res;
    });
    this._chatPage++;
    this.buildChatAndSort(true, tempUserList, responseChat);
    this.filterListWithChecked();

    return responseEmail;
  }

  async fetchTodoTaskList() {
    let tempUserList: any = [];
    /**
     * 1. 우선 이메일 데이터 가져와 보여주기.
     */
    this._todoPage++;
    const responseEmail = await this.fetchEmailData().then(async (res) => {
      // const userList = await this.fetchUsers(res);
      // tempUserList = [...userList];
      return res;
    });
    this._tempTaskEmailTotal = responseEmail.total;

    this._emailPage++;
    this.buildEmail(false, tempUserList, responseEmail);
    this.filterListWithChecked();

    /**
     * 2. 우선 챗 데이터 가져와 보여주기.
     */
    const responseChat = await this.fetchChatData().then(async (res) => {
      // const userList = await this.fetchUsers(res);
      // const tempUserSet = new Set([...tempUserList, ...userList]);
      // tempUserList = [...tempUserSet];
      return res;
    });
    this._tempTaskChatTotal = responseChat.total;

    this._total = this._tempTaskEmailTotal + this._tempTaskChatTotal;
    this._chatPage++;
    this.buildChatAndSort(false, tempUserList, responseChat);
    this.filterListWithChecked();

    return responseEmail;
  }

  @action
  async fetchTaskList(userInfo: UserModel | undefined) {
    try {
      this._isLoading = true;
      this.initStore();
      this._userInfo = userInfo!;

      if (this._tabsValue === "DONE") {
        const response = await this.fetchDoneTaskList();
        //this._isLoading = false;
        return response;
      } else {
        // TODO 관련...
        const response = await this.fetchTodoTaskList();
        //this._isLoading = false;
        return response;
      }
    } catch (err) {
      throw err;
    } finally {
      this._isLoading = false;
    }
  }

  async fetchMoreDoneTaskList() {
    let tempUserList: any = [];
    let tempUserIdlist = new Set<String>();

    this._donePage++;

    let responseEmail: any = {
      docs: [],
      children: [],
    };

    if (this._tempTaskEmailTotal > this._pageSize * this._emailPage) {
      responseEmail = await this.fetchDoneEmailData().then(async (res) => {
        for (let i = 0; i < res.children?.length; i++) {
          tempUserIdlist.add(res.children[i].userId);
        }
        // const userList = await this.fetchUsers(res);
        // tempUserList = [...userList];
        return res;
      });
      this._emailPage++;

      this.buildEmail(true, tempUserList, responseEmail);
      this.filterListWithChecked();
    }

    if (this._tempTaskChatTotal > this._pageSize * this._chatPage) {
      const responseChat = await this.fetchDoneChatData().then(async (res) => {
        for (let i = 0; i < res.children?.length; i++) {
          tempUserIdlist.add(res.children[i].userId);
        }

        const userList = await this.fetchUsers(tempUserIdlist);
        tempUserList = [...userList];
        return res;
      });
      this._chatPage++;

      this.buildChatAndSort(true, tempUserList, responseChat);
    }
    this.filterListWithChecked();

    return responseEmail;
  }

  async fetchMoreTodoTaskList() {
    let tempUserList: any = [];
    /**
     * 1. 우선 이메일 데이터 가져와 보여주기.
     */
    this._todoPage++;

    let responseEmail: any = {
      docs: [],
      children: [],
    };

    if (this._tempTaskEmailTotal > this._pageSize * this._emailPage) {
      responseEmail = await this.fetchEmailData().then(async (res) => {
        // const userList = await this.fetchUsers(res);
        // tempUserList = [...userList];
        return res;
      });
      this._emailPage++;
      this.buildEmail(false, tempUserList, responseEmail);
    }
    this.filterListWithChecked();

    /**
     * 2. 우선 챗 데이터 가져와 보여주기.
     */
    if (this._tempTaskChatTotal > this._pageSize * this._chatPage) {
      const responseChat = await this.fetchChatData().then(async (res) => {
        // const userList = await this.fetchUsers(res);
        // const tempUserSet = new Set([...tempUserList, ...userList]);
        // tempUserList = [...tempUserSet];
        return res;
      });
      this._chatPage++;
      this.buildChatAndSort(false, tempUserList, responseChat);
    }
    this.filterListWithChecked();

    if (this._taskList.length === 0) {
    }

    return responseEmail;
  }

  @action
  async fetchPrevData() {
    this._tabsValue === "DONE" ? this._donePage-- : this._todoPage--;

    this._originTaskList = this._response.docs;
    this.filterListWithChecked();
  }

  @action
  async fetchNextData() {
    await this.fetchMoreData();
  }

  @action
  async fetchMoreData() {
    try {
      this._isLoading = true;

      if (this._tabsValue === "DONE") {
        const response = await this.fetchMoreDoneTaskList();
        //this._isLoading = false;
        return response;
      } else {
        // TODO 관련...
        const response = await this.fetchMoreTodoTaskList();
        //this._isLoading = false;
        return response;
      }
    } catch (err) {
      throw err;
    } finally {
      this._isLoading = false;
    }
  }

  @action
  async skipUpdateDocs(assess: AssessModel) {
    const doc = {
      type: "ASSESS",
      id: assess.id,
      published: true,
      userData: {
        skip: false,
      },
    };

    await M5APIs.updateDocs(config.BUCKET_TASK!, [doc], "MERGE");
  }

  @action
  async createTaskAssess(
    task: TaskModel,
    emoji: string,
    skip?: boolean,
    userInfo?: UserModel
  ) {
    try {
      this._isLoading = true;

      const doc = {
        type: "ASSESS",
        parentId: task.id,
        userId: this._userInfo!.id,
        subtype: "VISIBLE",
        published: true,
        title: "",
        userData: {
          emoticon: emoji,
          skip: skip ? skip : "",
        },
      };
      console.log(doc);
      const res = await M5APIs.createDocs(config.BUCKET_TASK!, [doc], "STOP");

      // 평가 생성 이후
      // AGGREGATION 쪽에 점수 정보 추가
      //console.log(this.employee);
      const aggregationDocRes: any = await M5APIs.fetchDocById(
        this._employee?.userData.aggregationId!,
        "",
        "AGGREGATION",
        {}
      );

      let aggUpdateDocs = {};

      if (aggregationDocRes.docs?.userData.assessList) {
        aggUpdateDocs = {
          type: "AGGREGATION",
          id: this._employee?.userData.aggregationId,
          linkedIds: [
            ...aggregationDocRes.docs?.linkedIds,
            res.docs[0].parentId,
          ],
          published: true,
          userData: {
            assessList: [
              ...aggregationDocRes.docs?.userData.assessList,
              res.docs[0],
            ],
          },
        };
      } else {
        aggUpdateDocs = {
          type: "AGGREGATION",
          id: this._employee?.userData.aggregationId,
          linkedIds: [res.docs[0].parentId],
          published: true,
          userData: {
            assessList: [res.docs[0]],
          },
        };
      }

      await M5APIs.updateDocs(config.BUCKET_TASK!, [aggUpdateDocs], "MERGE");

      const userAggregationDocRes: any = await M5APIs.fetchDocById(
        userInfo?.userData.aggregationId!,
        "",
        "AGGREGATION",
        {}
      );

      let userAggUpdateDocs = userAggregationDocRes.docs;

      if (userAggUpdateDocs?.userData.doneList) {
        // 평가진행시 doneList가있을때

        // 평가진행시 doneList에 로그인한 유저의 AGGREGATION DOC에서 doneCount증가
        // doneList에 로그인한 유저의 값이 있다면
        if (
          userAggUpdateDocs?.userData.doneList.find(
            (done: AggregationDone) => done.user === this.employee?.id
          )
        ) {
          userAggUpdateDocs?.userData.doneList.forEach(
            (done: AggregationDone) => {
              if (done.user === this.employee?.id) {
                done.count = done.count + 1;
              }
            }
          );

          userAggUpdateDocs.userData = {
            ...userAggUpdateDocs.userData,
            doneList: [...userAggregationDocRes.docs?.userData.doneList],
          };
        }
        // doneList에 로그인한 유저의 아이디가 없다면
        else {
          userAggUpdateDocs.userData = {
            ...userAggUpdateDocs.userData,
            doneList: [
              ...userAggregationDocRes.docs?.userData.doneList,
              { user: this.employee?.id, count: 1 },
            ],
          };
        }
      }
      //최초 평가진행시 doneList가없을때
      else {
        userAggUpdateDocs.userData = {
          ...userAggUpdateDocs.userData,
          doneList: [{ user: this.employee?.id, count: 1 }],
        };
      }

      console.log(userAggUpdateDocs);

      await M5APIs.updateDocs(
        config.BUCKET_TASK!,
        [userAggUpdateDocs],
        "MERGE"
      );

      // 평가를 생성 한 이후에
      // 해당 TASK에 공개평가를 한적이 있는 ID는 userData.pubDoneIdList에
      // 비공개평가를 한적이 있는 ID는 userData.prvDoneIdList에 넣는다.
      let updateDocs = {};

      if (task.userData?.pubDoneIdList) {
        updateDocs = {
          type: "TASK",
          id: task.id,
          published: true,
          userData: {
            pubDoneIdList: [
              ...task.userData?.pubDoneIdList,
              this._userInfo?.id,
            ],
          },
        };
      } else {
        updateDocs = {
          type: "TASK",
          id: task.id,
          published: true,
          deleted: false,
          userData: {
            pubDoneIdList: [this._userInfo?.id],
          },
        };
      }

      const updateRes = await M5APIs.updateDocs(
        config.BUCKET_TASK!,
        [updateDocs],
        "MERGE"
      );
      this._selectedTask = updateRes.docs[0];

      await this.fetchTaskList(this._userInfo);
    } catch (error) {
      console.log(error);
    } finally {
      this._isLoading = false;
    }
  }

  @action
  setSelectedTask(selectedTask: TaskModel) {
    this._selectedTask = selectedTask;
  }
  @action
  setSelectedAssess(selectedAssess: AssessModel) {
    this._selectedAssess = selectedAssess;
  }
  @action
  setFilterValue(value: string) {
    this._filterValue = value;
  }

  @action
  setFilterLikeDown(filterLikeDown: boolean) {
    this._filterLikeDown = filterLikeDown;
  }

  @action
  setFilterLikeUp(filterLikeUp: boolean) {
    this._filterLikeUp = filterLikeUp;
  }

  @action
  setIsHTMLOpen(isHTMLOpen: boolean) {
    this._isHTMLOpen = isHTMLOpen;
  }

  @computed
  get total() {
    return this._total;
  }

  @computed
  get tabsValue() {
    return this._tabsValue;
  }

  @computed
  get taskList() {
    return this._taskList;
  }
  @computed
  get filteredList() {
    return this._filterList;
  }
  @computed
  get employee() {
    return this._employee;
  }
  @computed
  get isEmpty() {
    return this._taskList.length === 0;
  }
  @computed
  get isSkipOpenModal() {
    return this._isSkipOpenModal;
  }
  @computed
  get isOpenModal() {
    return this._isOpenModal;
  }
  @computed
  get isCloseModal() {
    return this._isCloseModal;
  }
  @computed
  get isOpenEditModal() {
    return this._isOpenEditModal;
  }
  @computed
  get isCloseEditModal() {
    return this._isCloseEditModal;
  }
  @computed
  get openPopper() {
    return this._openPopper;
  }
  get isLoading() {
    return this._isLoading;
  }

  @computed
  get emailCheck() {
    return this._emailCheck;
  }
  @computed
  get groupwareCheck() {
    return this._groupwareCheck;
  }
  @computed
  get isMoreBtn() {
    return this._isMoreBtn;
  }

  @computed
  get isHTMLOpen() {
    return this._isHTMLOpen;
  }

  @computed
  get chatAttachCheck() {
    return this._chatAttachCheck;
  }

  @computed
  get attachCheck() {
    return this._attachCheck;
  }

  @computed
  get chatCheck() {
    return this._chatCheck;
  }
  @computed
  get filterValue() {
    return this._filterValue;
  }

  @computed
  get filterLikeUp() {
    return this._filterLikeUp;
  }

  @computed
  get filterLikeDown() {
    return this._filterLikeDown;
  }

  @computed
  get selectedTask() {
    return this._selectedTask;
  }

  @computed
  get selectedAssess() {
    return this._selectedAssess;
  }

  get tabPage() {
    return this._tabsValue === "DONE" ? this._donePage : this._todoPage;
  }
}

export default EmployeeDetailPageStore;
